import React from "react";
import { connect } from "react-redux";

import CustomerService from "services/customer";

import ZeeTable from "components/ZeeTable";

import { update, create, remove } from "reducers/customer";

import { setBreadcrumbs } from "reducers/view";
class Customer extends React.Component {
  customerService = new CustomerService();

  constructor() {
    super(...arguments);
    this.props.setBreadcrumbs([{ name: "Customers", slug: "/customers" }]);
  }

  state = {
    data: null,
  };

  columns = {
    name: { name: "Name" },
    address: {
      name: "Address",
      format: (address, row) => {
        const {
          address1,
          address2,
          address3,
          address4,
          address5,
          address6,
          address7,
          address8,
          address9,
          address10,
        } = row;

        return [
          address1,
          address2,
          address3,
          address4,
          address5,
          address6,
          address7,
          address8,
          address9,
          address10,
        ]
          .reduce((agg, item) => (item ? [...agg, item] : agg), [])
          .join(", ");
      },
    },
    country: { name: "Country" },
    telephone: { name: "Telephone" },
    email: { name: "Email" },
  };

  get data() {
    return this.props.customer;
  }

  parseAddress(customer) {
    if (customer.address) {
      const address = customer.address
        .split(",")
        .map((line) => line.trim())
        .reduce((agg, item) => (item === "" ? agg : [...agg, item]), []);

      const updated = {
        address1: null,
        address2: null,
        address3: null,
        address4: null,
        address5: null,
        address6: null,
        address7: null,
        address8: null,
        address9: null,
        address10: null,
      };

      address.forEach((item, key) => {
        updated[`address${key + 1}`] = item ?? null;
      });

      customer = {
        ...customer,
        ...updated,
      };
    }

    return customer;
  }

  async onDelete(customer) {
    const result = await this.customerService
      .delete(customer)
      .then(({ data }) => data);
    if (result.success) {
      this.props.remove(result.data);
      return result.data;
    }
    return false;
  }

  async onEdit(customer) {
    customer = this.parseAddress(customer);

    const result = await this.customerService
      .update(customer)
      .then(({ data }) => data);
    if (result.success) {
      this.props.update(result.data);
      return result.data;
    }
    return false;
  }

  async onAdd(customer) {
    customer = this.parseAddress(customer);

    const result = await this.customerService
      .create(customer)
      .then(({ data }) => data);
    if (result.success) {
      this.props.create(result.data);
      return result.data;
    }
    return false;
  }

  render() {
    return (
      <ZeeTable
        title="Customer"
        columns={this.columns}
        data={this.data}
        hasPagination={true}
        hasSort={true}
        hasDelete={true}
        hasEdit={true}
        hasAdd={true}
        hasSearch={true}
        orderBy="name"
        onEdit={(customer) => this.onEdit(customer)}
        onDelete={(customer) => this.onDelete(customer)}
        onAdd={(customer) => this.onAdd(customer)}
      />
    );
  }
}

export default connect(
  (state) => {
    return {
      customer: state.customer.all,
    };
  },
  { update, create, remove, setBreadcrumbs }
)(Customer);
